import React from "react";
import IconProvider from "@/components/ui/IconProvider";

interface EmptyStateProps {
  hasCards: boolean;
  onClearFilters?: () => void;
}

export default function EmptyState({ hasCards, onClearFilters }: EmptyStateProps) {
  return (
    <div className="flex items-center justify-center py-16">
      <div className="text-center">
        <IconProvider
          iconstring={hasCards ? "fa-search" : "fa-folder-open"}
          size={48}
          className="text-gray-400 mb-4 mx-auto"
        />
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          {hasCards ? "No items match your search" : "The First Part of your puzzle starts here"}
        </h3>
        <p className="text-gray-500 mb-4">
          {hasCards 
            ? "Try adjusting your search terms or filters."
            : "Get started by creating your first template using the + button above."}
        </p>
        {onClearFilters && hasCards && (
          <button
            onClick={onClearFilters}
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            Clear all filters
          </button>
        )}
      </div>
    </div>
  );
}

